import asyncComponent from './../components/asyncComponent';
import AppBar from './map/appBar';
import Sidebar from './map/sidebar';

const AsyncMapScreen = asyncComponent(() => import('./components/map'));

const CODE = 'map';

const screen = {
    code: CODE,
    icon: null,
    path: [
        '/' + CODE + '/:entity?/:id?/:action?',
    ],
    content: AsyncMapScreen,
    appBar: AppBar,
    sidebar: Sidebar,
    appTitle: CODE,
    menuItem: {
        label: CODE
    }
};

export default screen;


// WEBPACK FOOTER //
// ./src/screens/map.js